import React, { useCallback, useMemo, useState } from 'react';
import InputDate from '../../../../../components/form/elements/date';
import { CalendarImage } from '../../../../../assets/icons/insex';
import { useTranslation } from 'react-i18next';
import { dateDifferenceInDays } from '../../../../../utils/date-helper';
import { useFormContext } from 'react-hook-form';
import Watch from '../../../../../components/form/elements/watch';

interface Props {
  rest: object;
}

function PeriodDates({ rest }: Props) {
  const { t } = useTranslation();
  const { getValues, setValue } = useFormContext();
  const [days, setDays] = useState(dateDifferenceInDays(getValues('date_from'), getValues('date_to')))

  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback(
    (key: string, params?: { days: number }) =>
      t(transKeyPrefix.concat(key), params),
    [t]
  );

  const handlePeriodChange = useMemo(() => () => {
    const updatedDays = dateDifferenceInDays(getValues('date_from'), getValues('date_to'));
    setDays(updatedDays);
    setValue('days', updatedDays);

    if (!!updatedDays) {
      const animals = getValues('animals');
      const products = getValues('products');

      products.forEach((product, productIndex) => {
        product.barns.forEach((warehouse, warehouseIndex) => {
          const newTotalAmount = warehouse.amount_for_one * animals.length * updatedDays;
          setValue(`products.${productIndex}.barns.${warehouseIndex}.product_amount_total`, newTotalAmount)
        })
      })
    }
  }, [getValues, setValue, setDays ])

  const DateFrom = useMemo(
    () =>
      Watch(
        InputDate('date_from', null, null, null, true, CalendarImage, true, true),
        handlePeriodChange
      ),
    [handlePeriodChange]
  );

  const DateTo = useMemo(
    () =>
      Watch(
        InputDate('date_to', null, null, null, true, CalendarImage, true, true),
        handlePeriodChange
      ),
    [handlePeriodChange]
  );

  return useMemo(
    () => (
    <div>
      <div className="flex flex-row justify-between my-1">
        <label className="basis-1/2 text-[#6F6F6F]">
          {tp('events.grazing.periods')}{' '}
          <span className="text-[#12589F] font-bold">*</span>
        </label>
        <span className="basis-1/4 text-[#12589F] font-medium text-right">
          {' '}
          {tp('events.grazing.days', { days })}
        </span>
      </div>
      <div className="flex gap-1">
        <span className="flex-1">
          <DateFrom {...rest} />
        </span>
        <span className="flex-1">
          <DateTo {...rest} />
        </span>
      </div>
    </div>
  ), [DateFrom, DateTo, rest, tp, days]);
}

export default PeriodDates;
